import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import { getFormattedRate, getMetricDataFromArray } from '../../Metrics/utils';
import ChrMetric from '../../../generic/PageUI/Compound/Metric/ChrMetric';
import OverviewSubMetric from '../OverviewSubMetric';

const Body = (props) => {
  const { metrics } = props;
  const totalConnectedUsers = getMetricDataFromArray(metrics, MetricUId.TOTAL_CONNECTED_USERS_WITH_ROLES);
  const allConnectedUsersOnetime = getMetricDataFromArray(metrics, MetricUId.ALL_CONNECTED_USERS_ONETIME_WITH_ROLES);
  const totalConnectedUsersForBothOngoingAndOnetime = getMetricDataFromArray(metrics, MetricUId.TOTAL_CONNECTED_USERS_FOR_BOTH_ONGOING_AND_ONETIME_WITH_ROLES);
  const totalPublishedUsers = getMetricDataFromArray(metrics, MetricUId.TOTAL_PUBLISHED_USERS_WITH_ROLES);
  const connectedRate = getMetricDataFromArray(metrics, MetricUId.CONNECTED_RATE_WITH_ROLES);
  const formattedConnectedRate = getFormattedRate(connectedRate, { numeratorExtractorKey: "connected" });
  const metricProps = {
    className: 'cui-border-gray border-radius-0-5-important p-3 d-flex align-items-center cui-management-report-temp-overview-metric',
    subMetricComponent: OverviewSubMetric,
    subMetricContainerClass: "justify-content-center flex-wrap"
  }

  const connectedUsersMetric = totalConnectedUsersForBothOngoingAndOnetime || totalConnectedUsers || allConnectedUsersOnetime;

  // TODO_AD_FLASH: for combined totalConnectedUsersForBothOngoingAndOnetime metric, the text should be greyed out since its not clickable.

  return (
    <WidgetBodyWrapper { ...props } >
      <ChrMetric { ...metricProps } { ...totalPublishedUsers } />
      <ChrMetric { ...metricProps } { ...connectedUsersMetric } />
      <ChrMetric { ...metricProps } { ...formattedConnectedRate } />
    </WidgetBodyWrapper>
  );
};

export default Body;
